import type { Feature, FeatureCollection, Polygon } from 'geojson'
import { BaseLayer } from '.'
import { api } from '@/api'
import { renderGeoJson, Subscriber, type EventArgs } from 'cesium-extends'
import { Cartographic, Math as CMath, Entity } from 'cesium'
import EfencePopup from '@/views/Map/Popup/EfencePopup.vue'

export class EfenceLayer extends BaseLayer {
  layername: string = '电子围栏'
  key: string = 'efence'
  constructor() {
    super()
    this.once('mounted', (viewer) => {
      this._subscriber = new Subscriber(viewer, { pickResult: { enable: true } })
    })
  }
  private async loadGeojson(): Promise<FeatureCollection> {
    const res = await api.efence.efenceControllerGetEfenceList()
    const featureCollection: FeatureCollection = {
      type: 'FeatureCollection',
      features: [],
    }
    res.data.forEach((el) => {
      const { geom, ...properties } = el
      const feature: Feature<Polygon> = {
        type: 'Feature',
        id: properties.efenceId,
        geometry: { type: 'Polygon', coordinates: [geom] },
        properties: properties,
      }
      featureCollection!.features.push(feature)
    })
    return featureCollection
  }
  async render(): Promise<void> {
    await this.datasource.load(await this.loadGeojson())
    await renderGeoJson(this.datasource, {
      type: 'polygon',
      style: {
        type: 'section',
        config: {
          field: 'efenceType',
          'section-type': 'natural',
          custom: [
            { label: '1', value: 'blue' },
            { label: '2', value: 'red' },
          ],
          'outline-color': 'white',
          opacity: 0.3,
        },
      },
    })
    this._subscriber?.add(
      this.datasource.entities.values,
      (movement, substance) => {
        this.popup(movement, substance)
      },
      'LEFT_CLICK'
    )
  }
  popup(ev: EventArgs, entity: Entity) {
    const viewer = this._viewer
    const position = ev.position
    if (!position || !viewer) return
    if (!entity) return
    const lnglatCartesian3 = Cartographic.fromCartesian(viewer.scene.pickPosition(position))
    const lnglat = [lnglatCartesian3.longitude, lnglatCartesian3.latitude].map(CMath.toDegrees) as [
      number,
      number,
    ]
    const id = entity.id
    if (!id) throw new Error('entity没有id')
    this.popupCtrl.popup({
      viewer,
      id,
      lnglat,
      Com: EfencePopup,
      properties: entity.properties?.getValue(),
    })
  }
}
